import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div>\n  {{yield}}\n</div>",{ moduleName: "my-phorest/components/ui/modal/-body/index.hbs" })